import React from "react";
import BankDetailsComp from "./bank-details";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_PUBLIC_KEY);

function BankDetails({ stripe }) {
  return (
    <div>
      <Elements stripe={stripePromise}>
        <BankDetailsComp />
      </Elements>
    </div>
  );
}

export default BankDetails;
